import { Ref } from 'vue';

const USER_CHANNEL_PREFIX = 'user-';

const NEW_USER_CHANNEL_PREFIX = 'useri-';

const OFFLINE_ORDER_AGREEMENT_ID = 33;

const OPTION_ORDER_AGREEMENT_ID = 36;

const USER_QUERY_KEYS = {
  agreementText: (id: Ref<number | undefined>) => ['agreement-text', id],
  agreements: ['user-agreements'],
  releaseNotes: ['release-notes'],
  customerClub: ['user-customers-club'],
  userBankAccounts: ['user-bank-accounts'],
};

const BIXO_INFO_LINK =
  'https://my.irfarabi.com/customer-club/bixo?utm_source=helium&utm_medium=web&utm_campaign=bixo%20info';

const BIXO_DISCOUNT_LINK =
  'https://my.irfarabi.com/customer-club/discount?list=%2Fdiscount&utm_source=helium&utm_medium=web&utm_campaign=trade%20to%20bixo#package-container';

const BIXO_RATIO = 0.00455;

const LABKAHND_BIXO_RATIO = 0.1;

export {
  USER_CHANNEL_PREFIX,
  OFFLINE_ORDER_AGREEMENT_ID,
  BIXO_INFO_LINK,
  BIXO_RATIO,
  LABKAHND_BIXO_RATIO,
  BIXO_DISCOUNT_LINK,
  USER_QUERY_KEYS,
  OPTION_ORDER_AGREEMENT_ID,
  NEW_USER_CHANNEL_PREFIX,
};
